import { createConnectQueryKey, useMutation } from '@connectrpc/connect-query'
import { useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { toaster } from '@enechain/ecloud-designsystem'

import { uploadMemberImage } from '~/gen/proto/bff/v1/common-BffCommonService_connectquery'
import { BffCommonService } from '~/gen/proto/bff/v1/common_pb'

export function useUploadProfileImage(): ReturnType<typeof useMutation> {
  const { t } = useTranslation()
  const queryClient = useQueryClient()

  return useMutation(uploadMemberImage, {
    onSuccess: () => {
      toaster.create({
        title: t('pages.profile.action.uploadImage.success'),
        type: 'success',
      })
      void queryClient.invalidateQueries({
        queryKey: createConnectQueryKey({
          schema: BffCommonService.method.getMemberProfile,
          cardinality: 'finite',
        }),
      })
    },
    onError: () => {
      toaster.create({
        title: t('pages.profile.action.uploadImage.error'),
        type: 'error',
      })
    },
  })
}
